import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { Icon } from "..";
import { DisplayText } from "../DisplayText/DisplayText";
import * as S from "./Stages.styled";
export var Stage = function (props) {
    var stage = props.stage, isLast = props.isLast, index = props.index, stageStyle = props.stageStyle;
    var navigate = useNavigate();
    var onClick = function () {
        if (stage.url) {
            navigate(stage.url);
            return;
        }
        if (stage.onClick) {
            stage.onClick(stage);
            return;
        }
    };
    return (_jsxs(S.Stage, { appearance: stage.appearance, onClick: onClick, hasClick: stage.onClick || stage.url, isLast: isLast, isActive: stage.isActive || false, style: stageStyle, hasIcon: !!stage.icon, children: [_jsx(DisplayText, { size: "extraSmall", subdued: true, space: "tight", children: stage.heading }), _jsxs(S.Body, { children: [_jsxs(S.Count, { children: [_jsx(S.CountNumber, { children: stage.count }), stage.countDescription && (_jsx(S.CountDescription, { children: stage.countDescription }))] }), stage.icon && (_jsx(S.Icon, { children: _jsx(Icon, { source: stage.icon, size: "large" }) }))] })] }, "stage-".concat(index)));
};
